import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  PLDialogComponent,
  PLDialogConfig,
} from '@common/components/pl-dialog';

@Injectable({
  providedIn: 'root',
})
export class PLDialogService {
  private readonly dialog = inject(MatDialog);

  /**
   * Opens a dialog with the provided configuration.
   *
   * @param config Dialog configuration
   * @returns Observable that completes when dialog is closed
   *
   * @example
   * this.plDialog.open({
   *   title: 'Security preferences saved',
   *   content: 'Your security preferences have been saved.',
   *   buttonLabel: 'I understand'
   * }).subscribe();
   */
  open(config: PLDialogConfig): Observable<void> {
    const dialogRef: MatDialogRef<PLDialogComponent, void> = this.dialog.open(
      PLDialogComponent,
      {
        width: '450px',
        disableClose: true,
        panelClass: 'pl-dialog-panel',
        data: config,
        autoFocus: false,
        restoreFocus: true,
      }
    );

    return dialogRef.afterClosed();
  }
}
